import { useCallback } from 'react'
import { useRouter } from 'next/router'
import { ILink } from 'src/types/generated/contentful'
import { Type } from '@/components/common'
import { ArrowSquareOut } from '@/components/svg'
import SegmentHandler from '@/services/analytics/SegmentHandler'
import { contentUtil } from '@/utils'

export interface Props {
  campaignSlug: string
  offerings: contentUtil.MappedContent<ILink>[]
}

const Offering: React.FC<Props> = ({ campaignSlug, offerings }) => {
  const router = useRouter()

  const handleClick = useCallback(
    (name, url) => {
      SegmentHandler.track('On Tap', {
        project: campaignSlug,
        location: router.asPath,
        section_name: 'body',
        element_name: 'link',
        value: name,
        target_url: url,
        action_type: 'tap',
      })
    },
    [campaignSlug, router.asPath]
  )

  if (!offerings.length) return null

  return (
    <div className="flex flex-col">
      {offerings.map(({ id, name, url }) => (
        <Type
          as="a"
          variant="title-md"
          key={id}
          href={url}
          target="_blank"
          rel="noreferrer"
          className="flex w-full items-center justify-between border-b border-core-gray-300 py-3.5 text-left text-lg font-semibold text-core-oxide-600 last:border-b-0 last:pb-0"
          onClick={() => handleClick(name, url)}
        >
          {name}
          <ArrowSquareOut stroke="#16B087" />
        </Type>
      ))}
    </div>
  )
}

export default Offering
